import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-enlarge-image-modal',
  templateUrl: './enlarge-image-modal.component.html',
  styleUrl: './enlarge-image-modal.component.css'
})
export class EnlargeImageModalComponent {

  @Input() enLargeImage: string = '';
  @Input() enLargeImgTitle: string = 'Image';

  rotationDegree: number = 0;
  zoomLevel: number = 1;

  //#region image functions
  rotateImage(degrees: number): void {
    this.rotationDegree += degrees;
  }

  zoomImage(factor: number): void {
    this.zoomLevel *= factor;
  }

  downloadImage() {
    if (!this.enLargeImage) {
      console.error('No image data found');
      return;
    }

    // 1. Identify the MIME type (e.g., image/jpeg)
    // If the string starts with "data:", we parse it. Otherwise, we assume jpeg.
      let mimeType = 'image/jpeg'; 
      if (this.enLargeImage.startsWith('data:')) {
        const foundMime = this.enLargeImage.match(/data:([^;]+);/);
        if (foundMime) mimeType = foundMime[1];
      }

      // 2. Prepare the link
      const link = document.createElement('a');
      
      // Ensure the href has the correct data prefix
      link.href = this.enLargeImage.startsWith('data:') 
        ? this.enLargeImage 
        : `data:${mimeType};base64,${this.enLargeImage}`;

      // 3. Set filename (extract extension from mimeType)
      const extension = mimeType.split('/')[1] || 'jpg';
      const fileName = this.enLargeImgTitle ? this.enLargeImgTitle.trim().toLowerCase() : 'download';
      
      link.download = `${fileName}.${extension}`;

      // 4. Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  }

  //#endregion

}
